<template>
    <page-outline :title="pageTitle">
      <template slot="pageContent">
        <b-row class="pb-3 no-gutter">
          <back-button></back-button>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <form-accordion v-else :title="$t('common.global.infos_provider')" :isTitleUpperCase="false">
          <b-row class="form-group">
            <b-col cols="6" class="form-group" v-if="isEditable && this.$engine.user.getUserNorm() !== '3'">
              <form-write-group-label-input v-model="name" isMandatory
                :inputLabel="$t('common.global.provider_title')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="6" class="form-group" v-else>
              <form-write-group-label-input v-model="name" disabled
                :inputLabel="$t('common.global.provider_title')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="6" v-if="isEditable && this.$engine.user.getUserNorm() !== '3'">
              <form-write-group-label-input v-model="identifier" isMandatory
                :inputLabel="$t('common.global.bic')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="6" class="form-group" v-else>
              <form-write-group-label-input v-model="identifier" disabled
                :inputLabel="$t('common.global.bic')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="6" class="form-group" v-if="this.formType === 'add' && canSelectNetwork">
              <label class="">
                {{ $t('common.global.clearing') }}
                <span class="color-red">* </span>
              </label>
              <select class="form-control" :class="networkValueError ? 'errorBorder' : ''" v-model="networkSelected" @blur="formHasError" @change="getNetworkDetails">
                <option v-for="network in networkItems" :key="network.id" :value="network">
                  {{ network.name == 'HRTP' ? $t('common.norm.giro') : network.name}}
                </option>
              </select>
              <div v-if="networkValueError" class="text-danger" Page>
                {{ $t('errors.is_mandatory', { mandatoryValue: $t('common.global.clearing').toLowerCase() }) }}
              </div>
            </b-col>
            <b-col cols="6" class="form-group" v-else-if="canSelectNetwork">
              <form-write-group-label-input v-model="networkSelected.name" disabled
                :inputLabel="$t('common.global.clearing')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 w-50" v-if="tokenioList.length">
            <b-col>
              <label>{{ $t('common.global.tokenio') }}
              </label>
            </b-col>
          </b-row>
          <b-row class="mb-2 w-50" v-if="tokenioList.length">
            <b-col>
              <div class="d-flex align-items-center justify-content-between px-3 py-2 radio-list">
                <b-col class="fw-bold">{{ $t('common.global.tokenio_name') }}</b-col>
                <b-col class="fw-bold">{{ $t('common.global.tokenio_idBank') }}</b-col>
                <div  v-if="tokenioList.length > 1" class="fw-bold col-1 d-flex justify-content-end">{{ $t('common.default') }}</div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="tokenioList.length"
            v-for="tokenio in tokenioList"
            :key="tokenio.id"
            class="mb-2 w-50"
            >
            <b-col>
              <div class="d-flex align-items-center justify-content-between px-3 py-2 bg-light radio-list" :class="selectedDefaultIdError ? 'errorBorder': 'border'" @click="selectDefaultIdTokenIO(tokenio.idTokenIO)">
                <b-col class="fw-bold">{{ tokenio.name }}</b-col>
                <b-col class="text-muted">{{ tokenio.idBank }}</b-col>
                <b-form-radio v-if="tokenioList.length > 1"
                  :value="tokenio.idTokenIO"
                  v-model="selectedDefaultId"
                  name="default-token"
                  class="col-1 d-flex justify-content-end"
                  :class="selectedDefaultIdError ? 'radio-border-error' : ''"
                  :disabled="!isEditable">
                </b-form-radio>
              </div>
            </b-col>
          </b-row>
          <div v-if="selectedDefaultIdError" page="" class="text-danger form-group">
            {{ $t('errors.is_mandatory', { mandatoryValue: $t('common.global.tokenio').toLowerCase() }) }}
          </div>
        </form-accordion>
        <b-col>
          <span class="color-red" v-if="isEditable">* {{ $t('common.required_fields') }}</span>
        </b-col>
        <b-row class="justify-content-end no-gutter">
          <b-button variant="primary" v-if="isEditable && formType !== 'add'"
            class="mx-3"
            @click="switchMode('view')">
            <span>{{ $t('common.cncl') }}</span>
          </b-button>
          <b-button variant="primary" v-if="canEdit && !isEditable && formType !== 'add'"
            class="mx-3"
            @click="switchMode('edit')">
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
          <b-button variant="primary" v-if="canDelete && !isEditable && formType !== 'add'"
            class="mx-3" @click="deleteProvider">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
          <b-button variant="primary" v-if="isEditable && formType !== 'add'"
            class="mx-3" @click="editProvider">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
          <b-button variant="primary" v-if="formType === 'add'"
            class="mx-3" @click="addProvider">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
        </b-row>
      </template>
    </page-outline>
  </template>
<script>

import _ from 'lodash'

import backButton from "@/components/common/backButton.vue"
import ConfigEntreeForm from '@/pages/routing/global/ConfigEntreeForm.vue'
import ConfigSortieForm from '@/pages/routing/global/ConfigSortieForm.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
name: 'ProviderForm',
components: {
    'back-button': backButton,
    'config-entree-form': ConfigEntreeForm,
    'config-sortie-form': ConfigSortieForm,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
},
computed: {
  canDelete () {
    return this.$engine.rights.rightIs('rtp_member_supprimer', true) && this.$engine.user.getUserNorm() !== '3'
  },
  canEdit () {
    return this.$engine.rights.rightIs('rtp_member_supprimer', true) && (this.tokenioList.length > 1 || this.$engine.user.getUserNorm() !== '3')
  },
  canSelectNetwork () {
    return !this.$engine.user.getUserNorm() || this.$engine.rights.rightIs('super_admin', true)
  },
  isEditable () {
    return this.formType === 'add' || this.formType === 'edit'
  },
  pageTitle () {
    return this.$i18n.t('common.global.' + this.mode + '_provider')
  }
},
data: () => {
  return {
    activateSpinner: false,
    configIn: {},
    currentProvider: {},
    formType: 'add',
    identifier: '',
    networkItems: [],
    networkSelected: {},
    networkValue: {},
    networkValueError: false,
    name: '',
    originIdentifier: '',
    originName : '',
    providerType: 'PROVIDER',
    providerTypeError: false,
    providerTypeList: [],
    selectedDefaultId: '',
    selectedDefaultIdError: false,
    tokenioList: []
  }
},
created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.providerTypeList = [
      {
        id: 1,
        name: "CUSTOMER",
      },
      {
        id: 2,
        name: "PROVIDER",
      },
      {
        id: 3,
        name: "SI",
      },
    ]
    this.getNetworks()
    if (this.formType === 'view') {
      this.getProviders()
    } else {
      this.activateSpinner = false
    }
},
methods: {
  addProvider () {
    let that = this

    this.Dom7('input').addClass('display-error')
    this.Dom7('input').focus()
    this.Dom7('button').focus()
    this.Dom7('input').removeClass('display-error')

    if (this.formHasError()) {
      return
    }

    let configsOutOnlyId = _.cloneDeep(this.selectedNetwork.configOut)
    configsOutOnlyId.forEach(element => {
      delete element.format
      delete element.message
      delete element.webServiceURI
    });

    let params = {
      name: this.name,
      identifier: this.identifier,
      type: this.providerType,
      idNetwork: this.networkSelected.id,
      configsOutOnlyId: configsOutOnlyId
    }
    this.$engine.routing.member.create(params)
    .then(resp => {
        that.$f7.modal({
          title: this.$t('common.global.provider_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/provider'})
      })
      .catch(e => {
        errorMessageAlert(e, this)
        this.okMessageBox(this.$t('common.global.provider_addition_error'))
      })
  },
  deleteProvider () {
    let that = this
    let params = {
      idMember: this.id,
    }
    this.$engine.routing.member.delete(params)
    .then(resp => {
        that.$f7.modal({
          title: that.$t('common.global.provider_deleted'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/provider'})
      })
      .catch(e => {
        errorMessageAlert(e, this)
        this.okMessageBox(this.$t('common.global.provider_deletion_error'))
      })
  },
  editProvider () {
    let that = this

    this.Dom7('input').addClass('display-error')
    this.Dom7('input').focus()
    this.Dom7('button').focus()
    this.Dom7('input').removeClass('display-error')

    if (this.formHasError()) {
      return
    }

    let params = {
      idMember: this.id,
      identifier: this.identifier,
      name: this.name,
      idTokenio: this.selectedDefaultId ? this.selectedDefaultId : undefined
    }
    this.$engine.routing.member.edit(params)
    .then(resp => {
      that.$f7.modal({
        title: that.$t('common.global.provider_edited'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
      loadPage(that, {url: '/routing/provider'})
    })
    .catch(e => {
      errorMessageAlert(e, this)
      this.okMessageBox(this.$t('common.global.provider_edition_error'))
    })
  },
  fillFields(){
    this.name = this.originName = this.currentProvider.name
    this.identifier = this.originIdentifier = this.currentProvider.identifier
    this.providerType = this.currentProvider.type
    this.networkSelected = { id: this.currentProvider.idNetwork, name: this.currentProvider.network, norm: this.currentProvider.norm, idChannelIn: ""}
    this.tokenioList = this.currentProvider.tokenIO
    if (this.tokenioList.length) {
      this.selectedDefaultId = this.tokenioList.filter(elem => elem.default === '1').length ? this.tokenioList.filter(elem => elem.default === '1')[0].idTokenIO : ''
      this.originSelectedDefaultId = this.selectedDefaultId
    }
    this.activateSpinner = false
  },
  formHasError () {
    let hasError = false
    if ((this.networkSelected === undefined || this.networkSelected.name === '' || this.networkSelected.name === undefined) && this.formType === 'add') {
      this.networkValueError = true
      hasError = true
    } else {
      this.networkValueError = false
    }

    if (this.name === undefined || this.name === '') {
      hasError = true
    }

    if ( this.identifier === undefined || this.identifier === '') {
      hasError = true
    }
    if (this.tokenioList.length) {
      if (!this.selectedDefaultId) {
        this.selectedDefaultIdError = true
        hasError = true
      } else {
        this.selectedDefaultIdError = false
      }
    }
    return hasError
  },
  getProviders() {
    this.$engine.routing.member.fetch({idMember: this.id})
      .then(resp => {
        let that = this
        let providerList = {}
        providerList = resp.data.Member
        that.updateProvider(providerList)
      })
  },
  getNetworkDetails () {
    let that = this
    this.$engine.routing.network.fetch({id: this.networkSelected.id})
    .then(resp => {
      let selectedNetwork = {}

      selectedNetwork = resp.data.networks
      that.updateNetworkDetails(selectedNetwork)

      this.$f7.pullToRefreshDone()
    })
  },
  getNetworks () {
    let that = this

    this.$engine.routing.network.fetch()
    .then(resp => {
      let networkList = {}

      networkList = resp.data.networks
      that.updateNetworks(networkList)

      this.$f7.pullToRefreshDone()
      if (!this.$engine.rights.rightIs('super_admin', true)) {
        this.networkItems.forEach(element => {
          if (element.id == this.$engine.user.getUserNorm()){
            this.networkSelected = element
          }
        })
      }
      this.getNetworkDetails()
    })
  },
  okMessageBox (message) {
    this.$f7.modal({
      title: message,
      buttons: [
        {
          text: 'OK',
          onClick: function () {
            return
          }
        }
      ]
    })
  },
  selectDefaultIdTokenIO (id) {
    if (this.isEditable) {
      this.selectedDefaultId = id
    }
  },
  switchMode (mode) {
    if (mode === 'view') {
      this.networkValueError = false
      this.selectedDefaultIdError = false
      this.name = this.originName
      this.identifier = this.originIdentifier
      this.selectedDefaultId = this.originSelectedDefaultId
    }
    this.formType = mode
  },
  updateProvider (providerList) {
    this.currentProvider = providerList
    this.fillFields()
  },
  updateNetworkDetails (selectedNetwork) {
    this.selectedNetwork = selectedNetwork[0]
  },
  updateNetworks (networkList) {
    this.networkItems = networkList
  }
},
watch: {
}
}
</script>
